import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./index.css";
import App from "./App";
import { queryClient } from "./clients/ReactQueryClient";
import { UserProvider } from "./context/UserContext";
import { LayoutProvider } from "./context/LayoutContext";

// Create Posthog client
// Performed here to bootstrap feature flag loading regardless if the library has fully loaded.
posthog.init(import.meta.env["VITE_POSTHOG_PUBLIC_KEY"], {
    api_host: import.meta.env["VITE_POSTHOG_HOST"],
    bootstrap: {
        featureFlags: {
            "initial-rollout-features-requisitions": "false"
        }
    },
    session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
            password: true
        }
    }
});

// when a deployment occurs then the sourcemap is busted and the user will see an error.  just refresh the page in that case to refetch.
window.addEventListener("vite:preloadError", () => {
    window.location.reload();
});

const ShowTanstackDevtools = import.meta.env.DEV && import.meta.env["VITE_TANSTACK_DEV_ENABLED"] === "true";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <QueryClientProvider client={queryClient}>
        <PostHogProvider client={posthog}>
            <UserProvider>
                <LayoutProvider>
                    <App />
                    {ShowTanstackDevtools && <ReactQueryDevtools buttonPosition="bottom-left" />}
                </LayoutProvider>
            </UserProvider>
        </PostHogProvider>
    </QueryClientProvider>
);
